<template>
	<div class="part palavra">
		<div v-html="part.PartEnunciado" class="enunciado">
		</div>
		<div class="conteudo">
		</div>
		<answer-box 
		ref="answerbox"
		:locked="locked"
		@respondeu="respondeu" 
		@page-changed="pageChanged" 
		:part="part"></answer-box>
	</div>
</template>

<script>
	import AnswerBox from '../AnswerBox'
	export default {
		props: ['part', 'locked'],

		data() {
			return {
				partId: null,
				parsedConteudo: '',
				el: null
			}
		},

		watch: {
			part() {
				if(this.part.PartId !== this.partId) {
					this.init()
				}
			}
		},

		mounted() {
			this.init()
		},

		methods: {

			init() {
				this.el = $(this.$el)
				this.parseConteudo()
				this.fillBlanks()
				this.partId = this.part.PartId
			},

			respondeu(opcao, index) {
				var blank = this.getBlankByIndex(index)
				if(opcao !== undefined) {
					blank.html(opcao.Texto)
				}
			},


			parseConteudo() {
				this.parsedConteudo = this.part.PartConteudo.replace(/\{\((.+?)\)\}/g, function(m, c) {
					return '<strong class="answer" data-index="'+ c +'">_______</strong>'
				})

				this.el.find('.conteudo').html(this.parsedConteudo)
				this.setBlankAsActive(1)
				var that = this
				this.el.find('[data-index]').click(function () {
					var index = parseInt($(this).attr('data-index'))

					that.$refs.answerbox.setByNumber(index)
					that.setBlankAsActive(index)
				});
			},

			pageChanged(index) {
				this.setBlankAsActive(index)
			},

			fillBlanks() {
				var mapped = []
				this.part.Perguntas.forEach((el, i) => {
					var opcao = el.Opcoes.find((op) => {
						return el.RespostaId == op.Id
					})

					this.respondeu(opcao, i + 1)
				})
			},

			setBlankAsActive(index) {
				this.el.find('[data-index]').removeClass('active')
				var blank = this.getBlankByIndex(index)
				blank.addClass('active')
			},

			getBlankByIndex(index) {
				return this.el.find("[data-index='" + index + "']")
			}
		},

		components: {
			'answer-box': AnswerBox
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/perguntas/lacuna-palavra/PerguntaPalavra.vue